import { Grid, IconButton, InputBase, Paper, Typography } from '@mui/material';
import React from 'react'
import SendIcon from '@mui/icons-material/Send';
import { useNavigate } from 'react-router-dom';
import logoempresa from '../../../media/logoempresa.png';
import { convertirEnlaces } from '../../../utils/utils';

export const ChatInterno = ({ comentariosInternos, enviarComentario, mensajeInterno, handleInputChangeInterno, handleKeyPress, enviarComentarioInterno }) => {
    const navigate = useNavigate();


    return (
        <>
            <div className='envase-chat-interno'>
                <Grid container xs={12} direction={'row'} justifyContent={'space-between'} >
                    <strong>&nbsp;Comentarios Internos:</strong>
                    <img src={logoempresa} alt="Logo" className="logo-chat" onClick={() => navigate('/')} />
                </Grid>

                <div className='contenedor-chat' style={{ minHeight: '22vh', maxHeight: '22vh', overflow: 'auto' }}>
                    {comentariosInternos.map((comentario => (
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            xs={8}
                            className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                            key={comentario.id}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="start"
                                alignItems="start"
                                xs={12}
                            >
                                <Typography variant='subtitle1' sx={{ color: comentario.color, textAlign: 'left' }} >
                                    <strong>{comentario.nombre}</strong>
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="start"
                                alignItems="start"
                                xs={12}
                            >
                                <Typography variant='body2' className='texto-con-salto'>
                                    {convertirEnlaces(comentario.comentario)}
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="end"
                                alignItems="end"
                                xs={12}
                            >
                                <Typography variant='caption'>
                                    <strong>{comentario.fecha}</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    )))}

                </div>
                <Grid xs={12} className='chat-bar'>
                    <Paper
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                        variant='outlined'
                        onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Escribe un mensaje nuevo"
                            inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                            name='mensajeInterno'
                            value={mensajeInterno}
                            onChange={handleInputChangeInterno}
                            onKeyPress={handleKeyPress}
                        />
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                            <SendIcon onClick={() => enviarComentarioInterno()} />
                        </IconButton>
                    </Paper>
                </Grid>
            </div>

        </>
    )
}
